(ns frontend.view.grid.zap-vaults-grid.event
  (:require [frontend.view.entity :as f-entity]
            [frontend.view.grid.zap-vaults-grid.model :as model]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::init
 (fn [{_db :db} _]
   ;{:db (assoc-in db model/loading-full-path true)}
   ))

(rf/reg-event-fx
 ::set-show-inactive
 (fn [{db :db} [_ v]]
   {:db (assoc-in db model/show-inactive-full-path v)}))

(rf/reg-event-fx
 ::set-show-only-my
 (fn [{db :db} [_ v]]
   {:db (assoc-in db model/show-only-my-full-path v)}))

(rf/reg-event-fx
 ::set-search-text
 (fn [{db :db} [_ v]]
   {:db (assoc-in db model/search-text-full-path v)}))

(rf/reg-event-fx
 ::create-new-vault
 (fn [{_db :db} _]
   (f-entity/open-creator!
    :entity.type/zap-vault
    {:on-ok! (fn [{:keys [close-cb!] :as _ok-args}]
               (close-cb!))})
   nil))
